import BifrostSegment from "@/Components/BifrostElementComponent/BifrostSegment/BifrostSegment"
import { SubnetMappings } from "@/Components/layouts"
import React from "react"
import { Dimmer, Divider, Icon, Message, Segment } from "semantic-ui-react"
import { useDirectTunnelSettings } from "../hooks/useDirectTunnelSettings"
import { disableDirectTunnelMessage } from "../store/states"
import DirectTunnelToggleButton from "./DirectTunnelToggleButton"
import ServiceStatus from "./ServiceStatus"

/**
 * Direct Tunnel Settings component template
 * @param {object} props
 * @param {object} props.data
 * @param {React.MutableRefObject} ref
 */
const DirectTunnelSettings = ({ data }, ref) => {
	const { directTunnelStatus, directTunnelServiceStatus, refreshServiceStatus, dimmerDirectTunnel, handleDimmerDirectTunnel, fetchSubnetMappingRef, postRef } = useDirectTunnelSettings(ref, data)

	return (
		<Dimmer.Dimmable as={Segment} dimmed={dimmerDirectTunnel.isDimmed} blurring>
			<BifrostSegment
				segmentList={[
					[
						{
							key: "direct-tunnel-toggle",
							component: (
								<DirectTunnelToggleButton
									dimmerDirectTunnel={dimmerDirectTunnel}
									directTunnelStatus={directTunnelStatus}
									refreshServiceStatus={refreshServiceStatus}
									orgId={data?.org_id}
									handleDimmerDirectTunnel={handleDimmerDirectTunnel}
									ref={postRef}
								/>
							)
						}
					],
					[{ key: "service-status", component: <ServiceStatus directTunnelServiceStatus={directTunnelServiceStatus} /> }]
				]}
				// insert the subnet mapping into the page with the bottomSegment ref
				bottomSegment={<SubnetMappings directTunnelStatus={directTunnelStatus} ref={fetchSubnetMappingRef} />}
			/>
			<Dimmer active={dimmerDirectTunnel.isDimmed} inverted>
				<Message style={{ color: "black" }} info onDismiss={dimmerDirectTunnel.dimmerMessage === disableDirectTunnelMessage.AA_DEVICE ? null : () => handleDimmerDirectTunnel()}>
					<Message.Header style={{ color: "black" }}>
						Activating Direct Tunnel
						<Icon name="hourglass half" style={{ margin: "0 10px" }} />
					</Message.Header>
					<Divider />
					<div style={{ color: "black" }}>{dimmerDirectTunnel.dimmerMessage}</div>
				</Message>
			</Dimmer>
		</Dimmer.Dimmable>
	)
}

export default React.forwardRef(DirectTunnelSettings)
